// =====================================================================
// commande-prete/dates.js — Commandes prêtes v2 (16-10-2026)
// =====================================================================
// Heures et dates de Bruxelles pour les écrans du module (chargement, paramètres
// client). Une date absente ou illisible s'affiche « — » (jamais « Invalid Date »).
// Fonctions PURES : testées par frontend/test/commande-prete.test.mjs.
// =====================================================================

const BXL = { timeZone: 'Europe/Brussels' };
const lire = (d) => {
  if (d === null || d === undefined || d === '') return null;
  const t = new Date(d);
  return Number.isFinite(t.getTime()) ? t : null;
};

// « 14:24 »
export function heureBxl(d) {
  const t = lire(d);
  return t ? t.toLocaleTimeString('fr-BE', { ...BXL, hour: '2-digit', minute: '2-digit' }) : '—';
}

// Page client (anglais / français) : « 14 Oct 2026, 14:24 » / « 14 oct. 2026 14:24 ».
export function dateHeureBxlLangue(d, langue) {
  const t = lire(d);
  return t
    ? t.toLocaleString(langue === 'fr' ? 'fr-BE' : 'en-GB', { ...BXL, day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '—';
}

// « 14/10 14:24 » ; avec l'année : « 14/10/2026 14:24 »
export function dateHeureBxl(d, { annee = false } = {}) {
  const t = lire(d);
  return t
    ? t.toLocaleString('fr-BE', { ...BXL, day: '2-digit', month: '2-digit', ...(annee ? { year: 'numeric' } : {}), hour: '2-digit', minute: '2-digit' })
    : '—';
}
